import { render, staticRenderFns } from "./IeBlocker.vue?vue&type=template&id=65267b05&scoped=true&"
import script from "./IeBlocker.vue?vue&type=script&lang=js&"
export * from "./IeBlocker.vue?vue&type=script&lang=js&"
import style0 from "./IeBlocker.vue?vue&type=style&index=0&id=65267b05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65267b05",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VApp,VCard,VIcon})
